/* eslint-disable @typescript-eslint/no-explicit-any */
import { UUID } from "node:crypto";
import { baseApi } from "./baseApi";
import { ResponseData } from "@interfaces/response";
import { VISUAL_CONFIG_CODES, VisualConfigCode } from "@helpers/constantes";
import { ChecklistSectionDocuments, ChecklistDocuments, TextosLegales } from "@interfaces/catalogs";
import { normalizeChecklistSectionDocuments, normalizeChecklistDocuments } from "@components/CustomCheckList/functions";

export type VisualConfigValue = ChecklistSectionDocuments | ChecklistDocuments;

const catalogosApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getVisualConfig: build.query<VisualConfigValue, { tax_system_id: UUID; code: VisualConfigCode }>({
      query: ({ tax_system_id, code }) => `configuraciones/onboarding?tax_system_id=${tax_system_id}&code=${code}`,
      transformResponse: (response: ResponseData<any>, _meta, arg) => {
        const value = response?.data;

        if (arg.code === VISUAL_CONFIG_CODES.CHECKLIST_EXPEDIENTE) {
          return normalizeChecklistSectionDocuments(value);
        }

        if (
          arg.code === VISUAL_CONFIG_CODES.CHECKLIST_VISITA_OCULAR ||
          arg.code === VISUAL_CONFIG_CODES.CHECKLIST_FIRMA
        ) {
          return normalizeChecklistDocuments(value);
        }

        return Array.isArray(value) ? value : [];
      },
    }),
    // Misma config visual con el código `TEXTOS_LEGALES`, pero es un objeto (no una lista): endpoint aparte para no
    // cambiar el tipo que reciben los checklists. Sin config (o con un valor que no es objeto) regresa `{}`.
    getTextosLegales: build.query<TextosLegales, { tax_system_id: UUID }>({
      query: ({ tax_system_id }) =>
        `configuraciones/onboarding?tax_system_id=${tax_system_id}&code=${VISUAL_CONFIG_CODES.TEXTOS_LEGALES}`,
      transformResponse: (response: ResponseData<any>) => {
        const value = response?.data;
        return value && typeof value === "object" && !Array.isArray(value) ? (value as TextosLegales) : {};
      },
    }),
  }),
});

export const { useLazyGetVisualConfigQuery, useLazyGetTextosLegalesQuery } = catalogosApi;
